export const urlWithParams = (url, params) => {
    const _url = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) {
            _url.searchParams.set(key, String(value));
        }
    });
    return decodeURIComponent(_url.toString());
};
//# sourceMappingURL=url.js.map